"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.startupMiddleware = exports["default"] = void 0;
var _appActions = require("../actions/appActions");
var _productActions = require("../actions/productActions");
var _instrumentActions = require("../actions/instrumentActions");
var _productManifestActions = require("../actions/productManifestActions");
var startupMiddleware = exports.startupMiddleware = function startupMiddleware(store) {
  return function (next) {
    return function (action) {
      if (action.type === _appActions.LOAD_STARTUP_DATA) {
        var selectedInstrumentId = Number(localStorage.getItem('selectedInstrumentId'));
        Promise.all([store.dispatch((0, _productActions.getProducts)()), store.dispatch((0, _instrumentActions.fetchInstruments)({
          selectedInstrumentId: selectedInstrumentId
        })), store.dispatch((0, _productManifestActions.getProductManifest)())]).then(function () {
          store.dispatch((0, _appActions.startupDataLoaded)());
        })["catch"](function (err) {
          return console.error(err);
        });
      }
      return next(action);
    };
  };
};
var _default = exports["default"] = startupMiddleware;